import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../../models/Common';
import { paymentsCardsApi } from '../../../../../../services/apiServices/user/paymentsCards';
import { useCustomSnackbar } from '../../../../../../hooks/useCustomEnqueueSnackbar';
import { getErrorMessage } from '../../../../../../utils';

interface DeleteCardProps {
  cardNumber: string | undefined;
  cardId: string | undefined;
  isActiveCard: boolean | undefined;
  handleClose: () => void;
}

export const DeleteCard: FC<DeleteCardProps> = ({ cardNumber, cardId, isActiveCard, handleClose }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteCardAPI, { isLoading }] = paymentsCardsApi.useDeleteCardMutation();

  const handleDelete = async (id: string | undefined) => {
    if (id) {
      try {
        await deleteCardAPI(id)
          .unwrap()
          .then(() => {
            if (isActiveCard) {
              customEnqueueSnackbar(t('snackbar.cardRemoved'), 'warning');
              customEnqueueSnackbar(t('snackbar.regularPaymentDisabled'), 'warning');
            } else {
              customEnqueueSnackbar(t('snackbar.cardRemoved'), 'warning');
            }
            handleClose();
          });
      } catch (err) {
        const message = getErrorMessage(err);
        customEnqueueSnackbar(message, 'error');
        handleClose();
      }
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('accountSettings.delete?')}</article>
        <p className="modals__header__description">
          {isActiveCard ? (
            t('accountSettings.regularPaymentDeleteActiveCardWarning')
          ) : (
            <>
              {t('accountSettings.wantToDeleteCard')} <strong>{cardNumber}</strong>?
            </>
          )}
        </p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.delete')}
          handleClick={() => handleDelete(cardId)}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={isLoading}
        />
        <CustomMUIButton
          label={t('buttons.cancel')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
          isDisabled={isLoading}
        />
      </div>
    </div>
  );
};
